<div id="collapseExample"
     class="collapse show"
     [ngClass]="{
       'filter-fixed-carousel': tOp === 'inicio' && fixed,
       'filter-fixed-navbar': tOp !== 'inicio' && fixed
     }">

  <!-- ===================== HOME ===================== -->
  <div *ngIf="tOp === 'inicio'" class="filter-container">
    <!-- Tabs Venta / Alquiler -->
    <ul class="nav nav-tabs custom-tabs" id="filterTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link"
           [class.active]="!filterLS.tipoOpe || filterLS.tipoOpe === 'VENTA'"
           (click)="setOperacion('VENTA')">
          Venta
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link"
           [class.active]="filterLS.tipoOpe === 'ALQUILER'"
           (click)="setOperacion('ALQUILER')">
          Alquiler
        </a>
      </li>
    </ul>

    <!-- Formulario blanco -->
    <form class="form filter-box" (ngSubmit)="ObtenerPropiedades(f)" #f="ngForm">
      <div class="row g-2 align-items-end justify-content-center">
        
        <!-- Selects -->
        <div class="col-4 col-md-2">
          <select class="form-select"
                  id="localidades"
                  name="localidades"
                  [(ngModel)]="filterLS.localidad"
                  (ngModelChange)="saveToStorage()">
            <option *ngFor="let localidad of filter.localidades" [ngValue]="localidad.code">{{localidad.descripcion}}</option>
          </select>
        </div>        
        <div class="col-4 col-md-2">
          <select class="form-select"
                  id="tiposPro"
                  name="tiposPro"
                  [(ngModel)]="filterLS.tipoPr"
                  (ngModelChange)="loadDormitorios($event); saveToStorage()">
            <option *ngFor="let tipoPr of filter.tiposPro" [ngValue]="tipoPr.code">{{tipoPr.descripcion}}</option>
          </select>
        </div>
        <div class="col-4 col-md-2">
          <select class="form-select"
                  id="dormitorios"
                  name="dormitorios"
                  [(ngModel)]="filterLS.dormitorio"
                  (ngModelChange)="saveToStorage()">
            <option *ngFor="let dormitorio of filter.dormitorios" [ngValue]="dormitorio.code">{{dormitorio.descripcion}}</option>
          </select>
        </div>

        <!-- ✅ Campo extra SOLO admin -->
        <div *ngIf="adminMode" class="col-12 col-md-3">
          <input type="text"
                 class="form-control"
                 placeholder="Buscar por dirección"
                 name="direccion"
                 [(ngModel)]="filterLS.direccion"
                 (ngModelChange)="saveToStorage()">
        </div>

        <!-- Checks -->
        <div class="col-12 col-md-5 text-center filter-checks">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="cochera" name="cochera"
                   [(ngModel)]="filterLS.cochera" (ngModelChange)="saveToStorage()">
            <label class="form-check-label" for="cochera">Cochera</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="patio" name="patio"
                   [(ngModel)]="filterLS.patio" (ngModelChange)="saveToStorage()">
            <label class="form-check-label" for="patio">Patio</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="apCredito" name="apCredito"
                   [(ngModel)]="filterLS.apCredito" (ngModelChange)="saveToStorage()">
            <label class="form-check-label" for="apCredito">Apto Crédito</label>
          </div>
        </div>

        <!-- Botón -->
        <div class="col-12 col-md-1 text-center">
          <button class="btn btn-search w-100" type="submit">
            <i class="fas fa-search"></i> 
          </button>
        </div>

      </div>
    </form>
  </div>

  <!-- ===================== PROPIEDADES ===================== -->
<!-- ===================== PROPIEDADES (modo admin) ===================== -->
<div *ngIf="tOp !== 'inicio'" class="container-fluid filter animated fast">
  <form class="form" (ngSubmit)="ObtenerPropiedades(f)" #f="ngForm">
    <div class="row justify-content-center">



      <!-- Localidad -->
      <div class="col-4 col-md-1">
        <select class="custom-select d-block w-100" id="localidades" name="localidades"
                [(ngModel)]="filterLS.localidad" (ngModelChange)="saveToStorage()">
          <option *ngFor="let localidad of filter.localidades" [ngValue]="localidad.code">
            {{localidad.descripcion}}
          </option>
        </select>
      </div>
      <!-- Tipo de operación SOLO admin -->
      <div *ngIf="adminMode" class="col-4 col-md-2">
        <select class="custom-select d-block w-100"
                id="tipoOpe"
                name="tipoOpe"
                [(ngModel)]="filterLS.tipoOpe"
                (ngModelChange)="saveToStorage()">
          <option *ngFor="let ope of filter.tiposOpe" [ngValue]="ope.code">
            {{ope.descripcion}}
          </option>
        </select>
      </div>
      <!-- Tipo Propiedad -->
      <div class="col-4 col-md-1">
        <select class="custom-select d-block w-100" id="tiposPro" name="tiposPro"
                [(ngModel)]="filterLS.tipoPr"
                (ngModelChange)="loadDormitorios($event); saveToStorage()">
          <option *ngFor="let tipoPr of filter.tiposPro" [ngValue]="tipoPr.code">
            {{tipoPr.descripcion}}
          </option>
        </select>
      </div>

      <!-- Dormitorios -->
      <div class="col-4 col-md-1">
        <select class="custom-select d-block w-100" id="dormitorios" name="dormitorios"
                [(ngModel)]="filterLS.dormitorio" (ngModelChange)="saveToStorage()">
          <option *ngFor="let dormitorio of filter.dormitorios" [ngValue]="dormitorio.code">
            {{dormitorio.descripcion}}
          </option>
        </select>
      </div>

      <!-- Dirección -->
      <div *ngIf="adminMode" class="col-8 col-md-3">
        <input type="text"
               class="form-control"
               placeholder="Buscar por dirección"
               name="direccion"
               [(ngModel)]="filterLS.direccion"
               (ngModelChange)="saveToStorage()">
      </div>

      <!-- Checks -->
      <div class="col-12 col-md-3 d-flex justify-content-center filter-checks">
        <div class="form-check me-3">
          <input type="checkbox" class="form-check-input" id="cochera2" name="cochera"
                 [(ngModel)]="filterLS.cochera" (ngModelChange)="saveToStorage()">
          <label class="form-check-label" for="cochera2">Cochera</label>
        </div>
        <div class="form-check me-3">
          <input type="checkbox" class="form-check-input" id="patio2" name="patio"
                 [(ngModel)]="filterLS.patio" (ngModelChange)="saveToStorage()">
          <label class="form-check-label" for="patio2">Patio</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="apCredito2" name="apCredito"
                 [(ngModel)]="filterLS.apCredito" (ngModelChange)="saveToStorage()">
          <label class="form-check-label" for="apCredito2">Apto Crédito</label>
        </div>
      </div>

      <!-- Botón -->
      <div class="col-12 col-md-1 text-center">
        <button class="btn shadow-none w-100" type="submit">
          <i class="fas fa-search" style="font-size: 2em;"></i>
        </button>
      </div>
    </div>
  </form>
</div>

</div>
